module.exports = __webpack_public_path__ + "static/media/logo-white.63d1d1ba.png";